<template>
  <header class="main-header container">
    <nav class="nav container">
      <router-link to="/" class="logo">
        <img :src="Logo" alt="لوگوتبرک" />
      </router-link>
      <div class="nav__toggler">
        <div class="bar bar-one"></div>
        <div class="bar bar-two"></div>
        <div class="bar bar-three"></div>
      </div>
      <ul class="list nav__list">
        <li class="nav__item">
          <router-link to="/" class="link">درخواست واریزسود</router-link>
        </li>
        <li class="nav__item">
          <router-link to="/identity" class="link">هویتی</router-link>
        </li>
        <li class="nav__item">
          <router-link to="/connection" class="link">ارتباطی</router-link>
        </li>
        <li class="nav__item">
          <router-link to="/financial" class="link">مالی</router-link>
        </li>
        <li class="nav__item">
          <router-link to="/changePassword" class="link">تغییررمز</router-link>
        </li>
        <li class="nav__item">
          <router-link to="" @click="clear()">خروج</router-link>
        </li>
      </ul>
    </nav>
  </header>
</template>
<script>
import Logo from "../assets/img/logo.png";
export default {
  name: "head",
  data() {
    return { Logo };
  },
  mounted() {
    const toggler = document.querySelector(".nav__toggler");
    const navbar = document.querySelector(".nav");
    toggler.addEventListener("click", () => {
      navbar.classList.toggle("nav__expanded");
    });

    const tabs = document.querySelectorAll(".tab");
    const tabContents = document.querySelectorAll(".tab-content");
    tabs.forEach((tab) => {
      tab.addEventListener("click", () => {
        const targeTabContent = document.querySelector(
          `#${tab.dataset.tabTarget}`
        );
        tabs.forEach((tab) => tab.classList.remove("active"));
        tabContents.forEach((tabContent) =>
          tabContent.classList.remove("active")
        );
        tab.classList.add("active");
        targeTabContent.classList.add("active");
      });
    });

    const accordionHeaders = document.querySelectorAll(".accordion__header");
    const accordion = document.querySelector(".accordion");
    console.log(accordion);
    accordionHeaders.forEach((item) => {
      item.addEventListener("click", (e) => {
        console.log(e.target.parentElement);
        e.target.parentElement.classList.toggle("accordion__expanded");
      });
    });
    const rout = document.querySelectorAll(".link");
    rout.forEach(function (item) {
      item.addEventListener("click", function () {
      navbar.classList.remove("nav__expanded");
      });
    });
  },

  methods: {
    clear() {
      this.$store.dispatch("logout");
    },
  },
};
</script>
<style scoped>
.link.active {
  color: #fff;
  background-color: #d1a44f;
  border-radius: 5px;
  padding-right: 0.5rem;
  padding-left: 0.5rem;
}
.logo img {
  height: 55px;
  width: 120px;
}
.main-header {
  height: 60px;
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  background: #fff;
  margin-top: 15px;
  align-items: center;
  /* display: flex; */
  border-radius: 10px;
  transition: ease-in-out 0.3s;
  z-index: 997;
}
.nav {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
}
.nav__list {
  width: 100%;
  display: flex;
  flex-direction: column;
  max-height: 0;
  overflow: hidden;
  opacity: 0;
  transition: all 0.4s ease-out;
}
.nav.nav__expanded .nav__list {
  max-height: 100vh;
  opacity: 1;
  background: #fff;
  list-style: none;
  font-size: 0.75rem;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  margin-top: 5px;
}
.nav__item > a {
  text-decoration: none;
  display: block;
  padding: 0.5rem 0;
  color: #000;
}
.nav__item > a:hover {
  color: red;
  background-color: #d1a44f;
}
.nav__item {
  border-bottom: 1px solid #ccc;
}
.nav__toggler {
  cursor: pointer;
}
.bar {
  width: 25px;
  height: 3px;
  background-color: #000;
  margin: 5px 0;
  border-radius: 5px;
  transition: all 0.4s ease-out;
}

.nav.nav__expanded .bar-one {
  transform: rotate(-45deg) translate(-9px, 6px);
  margin: 8px 0;
}

.nav.nav__expanded .bar-two {
  opacity: 0;
  transform: translateX(-20px);
}

.nav.nav__expanded .bar-three {
  transform: rotate(45deg) translate(-8px, -8px);
  margin: 8px 0;
}
@media screen and (min-width: 991px) and (max-width: 1025px) {
  .main-header {
    display: flex;
    height: 80px;
  }
  .logo img {
    width: 220px;
    height: auto;
  }
  .logo {
    display: flex;
    justify-content: center;
    align-items: center;
    width: unset;
    height: unset;
  }
  .nav {
    padding: 0 2rem;
    justify-content: space-between;
  }
  .nav__toggler {
    display: none;
  }
  .nav__list {
    flex-direction: row;
    align-items: center;
    width: auto;
    opacity: 1;
    max-height: 100%;
    list-style: none;
    margin: 0;
  }
  .nav__item > a {
    font-weight: bold;
  }
  .nav__item {
    margin-right: 2rem;
    margin-bottom: 0;
    /* font-size: 1.6rem; */
    border: 0;
  }
  .nav__item > a:hover {
    color: #fff;
    background-color: #d1a44f;
    border-radius: 5px;
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }
}
@media screen and (min-width: 1028px) {
  .main-header {
    display: flex;
    height: 80px;
  }
  .logo img {
    width: 220px;
    height: auto;
  }
  .logo {
    display: flex;
    justify-content: center;
    align-items: center;
    width: unset;
    height: unset;
  }
  .nav {
    padding: 0 2rem;
    justify-content: unset;
  }
  .nav__toggler {
    display: none;
  }
  .nav__list {
    flex-direction: row;
    align-items: center;
    width: auto;
    opacity: 1;
    max-height: 100%;
    list-style: none;
    margin-right: 100px;
    margin-top: 1rem;
  }
  .nav__item > a {
    font-weight: bold;
  }
  .nav__item > a:hover {
    color: #fff;
    background-color: #d1a44f;
    border-radius: 5px;
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }
  .nav__item {
    margin-right: 2rem;
    margin-bottom: 0;
    /* font-size: 1.6rem; */
    border: 0;
  }
}
</style>
